import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from 'react-router-dom';
import MyTable from '../../../utils/MyTable';

import _, { isEmpty } from 'lodash';

//Api
import { FundAPI } from '../../../../API/fund';

//redux
import { useDispatch, useSelector } from 'react-redux';
import allActions from '../../../../actions';

import InfoIcon from '@material-ui/icons/Info';
import MoreIcon from '@material-ui/icons/MoreVert';

import { ClickAwayListener, Grow, IconButton, MenuItem, MenuList, Paper, Popper, Typography } from '@material-ui/core';
import moment from "moment";
import { ComDinheiroAPI } from '../../../../API/comdinheiro-api';
import { FundLocalQuotasAPI } from '../../../../API/fund_local_quotas';
import { headerSearch, tabs, unoTheme } from '../../../../assets/styles/unoTheme';
import { formatMyFundsToShow } from "../../../../controllers/FundController";
import InfosFundModal from '../../../modals/InfosFundModal';
import { codsInnerLoad } from "../../../utils/MyInnerLoad";
import {
    applyMaskAmount,
    getConsultingId,
    getDayMonthYearByDate,
    getFirstDayMonth,
    getLastDayInMonthByMonthAndYear
} from "../../../utils/utils";
import { ClientAPI } from '../../../../API/client';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import XLSX from 'xlsx';
import { downloadBlob, s2ab } from "../../../../controllers/ExcelController";
import { getMonthName } from "../../../utils/utils";

const LightTooltip = withStyles((theme) => ({
    arrow: {
        "&:before": {
            border: "1px solid #000000"
        },
        color: theme.palette.common.white
    },
    tooltip: {
        backgroundColor: theme.palette.common.white,
        border: "1px solid #000000",
        color: "#000000"
    }
}))(Tooltip);


const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    green: {
        color: unoTheme.greenMoney
    },
    red: {
        color: unoTheme.redMoney,
    },
    iconButton: {
        padding: '5px',
    },
    headerSearch: headerSearch,
    inputSearch: {
        width: "300px",
        background: "white"
    },
    tableTh: {
        //fontWeight: 'bold',
        background: unoTheme.mainColor,
        color: 'white',
    },
    selectableRow: {
        cursor: 'pointer',
        '& > *': {
            borderBottom: 'unset',
            //padding: '3px 12px 3px 8px !important',
        },
        '&:nth-of-type(odd)': {
            backgroundColor: unoTheme.secondaryTuplaTable,
        },
        '&:hover': {
            //color: 'white',
            background: unoTheme.hoverTable,
        }
    },

    table: {
        tableLayout: 'fixed',
        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                borderBottom: 'none',
                color: unoTheme.defaultTextColor,
                fontWeight: '500',
                textTransform: 'uppercase',
                fontSize: '12px',
                padding: '16px 24px 16px 16px',
            },
        },
    },

    overflow: {
        overflowY: 'scroll',
    },
    tableSideGraph: {
        display: 'flex',
        flexDirection: 'row',
    },
    rightGraphs: {
        width: '30%',
    },
    clickAble: {
        cursor: 'pointer'
    },
    sectionTableCell: {
        display: 'table-cell',
        color: 'white',
        padding: '0px !important',
    },
    multipleHorizontalTableCell: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'space-around',
        '& > div': {
            width: '20%',
        }
    },
    toogleButton: {
        maxHeight: '40px',
    },

    sortableSubHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        userSelect: 'none',
    },

    errorArticle: {
        color: unoTheme.errorColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& .MuiSvgIcon-root': {
            fontSize: '20px',
            marginRight: '5px',
        }

    },

    iconExtraPolicys: {

        '& .MuiSvgIcon-root': {
            fontSize: '18px',
            verticalAlign: 'middle',
        }

    },

    tabs: tabs,

    sectionTableCellData: {
        display: 'table-cell',
        padding: '0px !important',
    },

    infoIcon: {
        display: 'flex',
        fontSize: '18px',
        color: unoTheme.mainColor,
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto',
    }


}));

const RENT_COLUMNS = ["rentMonth", "rentYear", "rent12m", "rent24m", "rentHistoric"];

export default function FundsClientScreen({ segmentId, search, flagDoExcelMyFunds, includeRescuedFunds, resetFlag }) {

    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const clientOn = useSelector(state => state.clientOn)
    const currentUser = useSelector(state => state.currentUser);

    const dispatch = useDispatch();

    const [funds, setFunds] = useState([]);
    const [fundsFormatteds, setFundsFormatteds] = useState([]);

    const [filter, setFilter] = useState(1);

    const [clientOnScreen, setClientOnScreen] = useState("");

    const [settledFundsIds, setSettledFundsIds] = useState([]);

    const [orderBy, setOrderBy] = useState("fund_name"); //coluna
    const [order, setOrder] = useState("desc")    // direção

    async function getClientFunds(client, month, year, segmentId, search) {

        const currentPeriod = month + '/' + year;
        const startDate = moment.utc(client.portfolio_init).format('DD/MM/YYYY');
        const { month: initMonth, year: initYear } = getDayMonthYearByDate(moment.utc(client.portfolio_init));
        const endDate = getLastDayInMonthByMonthAndYear(month, year);
        // console.log('startDate: ', startDate);
        // console.log('endDate: ', endDate);
        console.log("SEGMENT ID getClientFunds: ", segmentId);

        //const responseRentsBack = await getRentsByPeriod(client.id, startDate, endDate, search, segmentId);
        //console.log("integralFundsBalancesMap back: ", JSON.stringify(responseRentsBack.integralFundsBalancesMap));

        const responseRents = await ClientAPI.getRentsByPeriod(client.id, startDate, endDate, search, segmentId);
        //const responseRents = await rentsByPeriod(client.id, startDate, endDate, search, segmentId);

        //console.log('responseRents: ', responseRents);

        if (responseRents.integralFundsBalancesMap) {

            if (Object.keys(responseRents.integralFundsBalancesMap).length) {

                const fundsIds = Object.keys(responseRents.integralFundsBalancesMap);

                const responseSettledFundsIds = await FundAPI.getSettledFundsIdsByFundsIdsAndReferenceDate(fundsIds, getFirstDayMonth(month, year));
                if (responseSettledFundsIds?.success) {

                    const setteldsIds = responseSettledFundsIds.body.rows.map(el => el.id + "");
                    console.log("setteldsIds: ", setteldsIds);
                    setSettledFundsIds(setteldsIds);
                }

                const responseFundsInfos = await FundAPI.getFundsInfosByFundIds(fundsIds);

                if (responseFundsInfos.success) {
                    //transformar em map
                    const mapFundsInfos = {};
                    responseFundsInfos.body.rows.forEach(el => {
                        mapFundsInfos[el.id] = el;
                    })

                    console.log('responseFundsInfos: ', responseFundsInfos);

                    if (isEmpty(responseRents.integralFundsBalancesMap)) {
                        dispatch(allActions.innerLoadActions.setInnerLoad({
                            show: true,
                            emptyMessage: 'Não existem fundos',
                            cod: codsInnerLoad.fundsClientScreen,
                        }));
                    } else {
                        dispatch(allActions.innerLoadActions.setInnerLoad({ show: false, cod: codsInnerLoad.fundsClientScreen }));
                    };

                    setFundsFormatteds(formatMyFundsToShow(responseRents.integralFundsBalancesMap, currentPeriod, mapFundsInfos));

                } else {
                    dispatch(allActions.innerLoadActions.setInnerLoad({
                        show: false,
                        cod: codsInnerLoad.fundsClientScreen,
                    }));

                    dispatch(allActions.mainAlertActions.setMainAlert({
                        show: true,
                        message: "Falha ao trazer fundos do cliente",
                        type: 'error',
                    }))
                }
            } else {
                dispatch(allActions.innerLoadActions.setInnerLoad({
                    show: true,
                    emptyMessage: 'Não existem fundos',
                    cod: codsInnerLoad.fundsClientScreen,
                }));
            }



        } else {

            dispatch(allActions.innerLoadActions.setInnerLoad({
                show: false,
                cod: codsInnerLoad.fundsClientScreen,
            }));

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                message: "Falha ao trazer fundos do cliente",
                type: 'error',
            }))
        }
    }

    function bladeFund(row) {
        console.log("FUND ROW: ", _.cloneDeep(row))
        history.push(
            {
                pathname: "/blade/all",
                state: { fund: row }
            }
        )
    };

    useEffect(() => {
        //Deve fazer a recarga apenas no caso de ter mudado o client, o ano selecionado ou a tab                
        const hasSearch = search || isEmpty(search) && clientOnScreen.id;
        if (
            (clientOn
                &&
                clientOn.client
                &&
                clientOn.client.id != clientOnScreen.id
            )
            || (clientOn && clientOn.client && clientOn.client.id && hasSearch)
        ) {

            if (segmentId != null && segmentId != undefined) {
                dispatch(allActions.innerLoadActions.setInnerLoad({
                    show: true,
                    cod: codsInnerLoad.fundsClientScreen,
                    loadMessage: 'Carregando fundos...',
                }));

                setClientOnScreen(_.cloneDeep(clientOn.client))

                if (clientOn.client.selectedPortfolioMonth && clientOn.client.selectedPortfolioYear) {
                    console.log("CHAMOU GET CLIENT FUNDS");
                    setFundsFormatteds(undefined);
                    getClientFunds(clientOn.client, clientOn.client.selectedPortfolioMonth, clientOn.client.selectedPortfolioYear, segmentId, search);
                } else {
                    dispatch(allActions.innerLoadActions.setInnerLoad({
                        show: true,
                        emptyMessage: 'Não existem fundos',
                        cod: codsInnerLoad.fundsClientScreen,
                    }));
                }
            }

        }

    }, [
        clientOn,
        location,
        segmentId,
        search
    ]);

    const selectable = useMemo(() => currentUser?.user?.isViewer ? undefined : "true", [currentUser]);

    //MENU
    const [selectedFundMenu, setSelectedFundMenu] = React.useState(false);
    const anchorRef = React.useRef(null);
    const [anchorEl, setAnchorEl] = useState(null);

    const openOptionsFundMenu = (e, fundRow) => {
        e.stopPropagation();
        console.log("openOptionsFundMenu: ", fundRow);
        setAnchorEl(e.currentTarget);
        setSelectedFundMenu(fundRow);
    }

    const handleCloseOptionsMenuFund = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setSelectedFundMenu(undefined);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setSelectedFundMenu(undefined);
        }
    }

    const handleBladeFund = (fund) => {
        if (!fund || currentUser?.user?.isViewer) return;
        bladeFund(fund);
    }

    const handleHistoricQuotasFund = (fund) => {
        if (!fund || currentUser?.user?.isViewer) return;
        dispatch(allActions.rightContentActions.setRightContent({
            path: 'fundLocalQuotas',
            data: fund,
        }))
    }

    const [openFundInfos, setOpenFundInfos] = useState();
    const [openFundFullCompositionModal, setOpenFundFullCompositionModal] = useState();

    const [fundInfos, setFundInfos] = useState();

    const handleInfosFund = async (fund, isFull) => {
        if (!fund || currentUser?.user?.isViewer) return;
        const { selectedMonth, selectedYear } = clientOn.client;
        const responseInfosLocais = await FundLocalQuotasAPI.getLocalInfosByFundIdMonthYear(fund.fundId, selectedMonth, selectedYear);
        if (responseInfosLocais.success && responseInfosLocais.body?.length === 1) {
            const { json_fund_infos } = responseInfosLocais.body[0];
            setFundInfos({
                ...selectedFundMenu,
                fund_id: parseInt(selectedFundMenu.fundId),
                ...JSON.parse(json_fund_infos)
            });
            isFull ? setOpenFundFullCompositionModal(true) : setOpenFundInfos(true);
        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: "warning",
                message: "Falha ao obter informações locais do fundo."
            }))
        }
    }

    const sortedFunds = useMemo(() => {
        if (!fundsFormatteds) return [];
        if (!orderBy) return fundsFormatteds;

        if (RENT_COLUMNS.includes(orderBy)) {
            const nullSentinel = order === "desc" ? -Infinity : Infinity;
            return _.orderBy(
                fundsFormatteds,
                [(row) => (row[orderBy] == null ? nullSentinel : row[orderBy])],
                [order]
            );
        }

        return _.orderBy(fundsFormatteds, [orderBy], [order]);
    }, [fundsFormatteds, orderBy, order]);

    //Fundos exibidos na tabela e exportados no Excel: sem os encerrados e, se o toggle
    //estiver desligado, sem os totalmente resgatados no mês selecionado
    const visibleFunds = useMemo(() => sortedFunds.filter(el =>
        !settledFundsIds.includes(el.fundId)
        && (includeRescuedFunds || !el.isFullyRescued)
    ), [sortedFunds, settledFundsIds, includeRescuedFunds]);

    const SortIcon = ({ column }) => {
        const isActive = orderBy === column;

        if (!isActive) {
            return <ArrowDropDown style={{ color: "#ccc" }} />;
        }

        return order === "asc" ? (
            <ArrowDropUp style={{ color: unoTheme.mainColor }} />
        ) : (
            <ArrowDropDown style={{ color: unoTheme.mainColor }} />
        );
    };

    const handleSort = (column) => {
        if (orderBy === column) {
            setOrder(order === "asc" ? "desc" : "asc");
        } else {
            setOrderBy(column);
            setOrder(RENT_COLUMNS.includes(column) ? "desc" : "asc");
        }
    };

    useEffect(() => {
        if (flagDoExcelMyFunds) {
            if (clientOn.client.selectedPortfolioMonth &&
                clientOn.client.selectedPortfolioYear && visibleFunds && visibleFunds.length > 0) {

                doExcelMyFunds(
                    clientOn.client.label_name + "_MEUS_FUNDOS_" + getMonthName(clientOn.client.selectedPortfolioMonth) + "_" + clientOn.client.selectedPortfolioYear,
                    clientOn.client.selectedPortfolioMonth,
                    clientOn.client.selectedPortfolioYear,
                    visibleFunds
                );
            }
            resetFlag();
        }
    }, [flagDoExcelMyFunds]);

    function doExcelMyFunds(titleFile, month, year, funds) {
        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Gerando planilha...',
        }));

        const wb = XLSX.utils.book_new();
        wb.Props = {
            Title: "Meus Fundos",
            Author: "UNO",
        }

        const sheetName = "Meus Fundos " + getMonthName(month) + "-" + year;
        wb.SheetNames.push(sheetName);

        const ws_data = [];

        ws_data.push(['Fundo', 'CNPJ', 'Rentabilidade Mês (%)', 'Rentabilidade Ano (%)',
            'Rentabilidade 12m (%)', 'Rentabilidade 24m (%)', 'Rentabilidade Início (%)'])

        funds.forEach(element => {
            ws_data.push([
                element.fund_name,
                element.cnpj,
                element.rentMonth ? applyMaskAmount(element.rentMonth, null, true) : '-',
                element.rentYear ? applyMaskAmount(element.rentYear, null, true) : '-',
                element.rent12m ? applyMaskAmount(element.rent12m, null, true) : '-',
                element.rent24m ? applyMaskAmount(element.rent24m, null, true) : '-',
                element.rentHistoric ? applyMaskAmount(element.rentHistoric, null, true) : '-',
            ])
        });

        const ws = XLSX.utils.aoa_to_sheet(ws_data);

        wb.Sheets[sheetName] = ws;
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })

        downloadBlob(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), titleFile + '.xlsx');

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: false,
        }));
    }

    return (
        <div className={classes.root}>

            <div class={'defaultScrollWithHeaderContent'}>
                <div className={classes.tableSideGraph}>
                    <MyTable stickyHeader
                        size="small">
                        <colgroup>
                            <col width="33%" />
                            <col width="25%" />
                            <col width="35%" />
                            <col width="7%" />
                        </colgroup>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left" onClick={() => handleSort("fund_name")}>
                                    <div style={{ display: 'flex', justifyContent: "flex-start", alignItems: 'center', }}>
                                        Fundo <SortIcon column={"fund_name"} />
                                    </div>
                                </TableCell>
                                <TableCell align="center">CNPJ</TableCell>
                                <TableCell className={classes.sectionTableCell}
                                    align="center">
                                    <div>{'Rentabilidade'}</div>
                                    <div className={classes.multipleHorizontalTableCell}>
                                        <div className={classes.sortableSubHeader} onClick={() => handleSort("rentMonth")}>
                                            {'Mês (%)'} <SortIcon column={"rentMonth"} />
                                        </div>
                                        <div className={classes.sortableSubHeader} onClick={() => handleSort("rentYear")}>
                                            {'Ano (%)'} <SortIcon column={"rentYear"} />
                                        </div>
                                        <div className={classes.sortableSubHeader} onClick={() => handleSort("rent12m")}>
                                            {'12m (%)'} <SortIcon column={"rent12m"} />
                                        </div>
                                        <div className={classes.sortableSubHeader} onClick={() => handleSort("rent24m")}>
                                            {'24m (%)'} <SortIcon column={"rent24m"} />
                                        </div>
                                        <div className={classes.sortableSubHeader} onClick={() => handleSort("rentHistoric")}>
                                            {'Início (%)'} <SortIcon column={"rentHistoric"} />
                                        </div>
                                    </div>
                                </TableCell>
                                <TableCell align="center">Ações</TableCell>
                            </TableRow>
                        </TableHead>

                        {
                            clientOn && clientOn.client ?
                                <TableBody>
                                    {visibleFunds.map((row, index) => (

                                        <TableRow
                                            key={'client-fund-' + index}
                                        // onClick={() => currentUser?.user?.isViewer ? undefined : bladeFund(row)}
                                        >
                                            <TableCell align="left">{row.fund_name}</TableCell>
                                            <TableCell align="center">{row.cnpj}</TableCell>
                                            <TableCell align="center"
                                                className={classes.sectionTableCellData}>
                                                <div className={classes.multipleHorizontalTableCell}>
                                                    <div>{
                                                        row.rentMonth ? applyMaskAmount(row.rentMonth, null, true) + "%" : '-'
                                                    }</div>
                                                    <div>{
                                                        row.rentYear ? applyMaskAmount(row.rentYear, null, true) + "%" : '-'
                                                    }</div>
                                                    <div>{
                                                        row.rent12m ?
                                                            applyMaskAmount(row.rent12m, null, true) + "%"
                                                            :
                                                            <LightTooltip title={'O fundo ainda não possui 12 meses na carteira'} placement="right" arrow>
                                                                <InfoIcon className={classes.infoIcon} />
                                                            </LightTooltip>
                                                    }</div>
                                                    <div>{row.rent24m != null ?
                                                        applyMaskAmount(row.rent24m, null, true) + "%"
                                                        :
                                                        <LightTooltip title={'O fundo ainda não possui 24 meses na carteira'} placement="right" arrow>
                                                            <InfoIcon className={classes.infoIcon} />
                                                        </LightTooltip>
                                                    }</div>

                                                    <div>{row.rentHistoric != null ? applyMaskAmount(row.rentHistoric, null, true) + "%" : '-'}</div>
                                                </div>
                                            </TableCell>
                                            <TableCell align="center" className="withIcons">{
                                                <IconButton onClick={(e) => openOptionsFundMenu(e, row)}>
                                                    <MoreIcon />
                                                </IconButton>
                                            }</TableCell>
                                        </TableRow>

                                    ))}
                                </TableBody>
                                : null
                        }
                    </MyTable>

                    <Popper
                        open={selectedFundMenu}
                        anchorEl={anchorEl}
                        transition
                        disablePortal>
                        {({ TransitionProps, placement }) => (
                            <Grow
                                {...TransitionProps}
                                style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                            >
                                <Paper>
                                    <ClickAwayListener onClickAway={handleCloseOptionsMenuFund}>
                                        {selectedFundMenu ?


                                            <MenuList autoFocusItem={selectedFundMenu} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                                <MenuItem
                                                    key={'menu-options-fund-blade'}
                                                    onClick={() => handleBladeFund(selectedFundMenu)}>
                                                    <Typography >{"Lâmina do fundo"}</Typography>

                                                </MenuItem>
                                                <MenuItem
                                                    key={'menu-options-fund-quotas-historic'}
                                                    onClick={() => handleHistoricQuotasFund(selectedFundMenu)}>
                                                    <Typography>{"Histórico de cotas"}</Typography>

                                                </MenuItem>
                                                {/* <MenuItem
                                                    key={'menu-test'}
                                                    onClick={() => handleTest()}>
                                                    <Typography>{"Teste"}</Typography>

                                                </MenuItem> */}
                                                {
                                                    getConsultingId(currentUser) === 1 ?
                                                        <MenuItem
                                                            key={'menu-options-fund-open-portfolio'}
                                                            onClick={() => handleInfosFund(selectedFundMenu)}>
                                                            <Typography>{"Carteira do fundo"}</Typography>

                                                        </MenuItem>
                                                        : null
                                                }

                                                {
                                                    getConsultingId(currentUser) === 1 ?
                                                        <MenuItem
                                                            //disabled
                                                            key={'menu-options-fund-open-portfolio-2'}
                                                            onClick={() => handleInfosFund(selectedFundMenu, true)}>
                                                            <Typography>{"Abrir carteira"}</Typography>

                                                        </MenuItem>
                                                        : null
                                                }
                                            </MenuList>
                                            : <div></div>
                                        }
                                    </ClickAwayListener>
                                </Paper>
                            </Grow>
                        )}
                    </Popper>

                </div>

            </div>

            <InfosFundModal
                isFull={openFundFullCompositionModal ? true : false}
                open={openFundInfos || openFundFullCompositionModal}
                fund={fundInfos ? fundInfos : null}
                handleCloseInfosFundModal={() => {
                    setOpenFundInfos(false);
                    setOpenFundFullCompositionModal(false);
                }}>

            </InfosFundModal>

        </div>
    );
}



